/* product read more 
$(document).ready(function () {
  var $description = $('.product-info__block-item[data-block-id="description"] .prose');

  if ($description.length === 0) return;
  if ($(window).width() > 768) return; // Only apply on mobile

  var maxHeight = 78; // px

  if ($description[0].scrollHeight > maxHeight) {
    $description.addClass('truncated-description');

    var $btn = $('<button/>', {
      text: '... Voir plus',
      class: 'read-more-toggle'
    });

    $description.parent().append($btn);

    $btn.on('click', function () {
      $description.toggleClass('open');
      $btn.toggleClass('open');

      var isOpen = $description.hasClass('open');
      $btn.text(isOpen ? 'Voir moins' : '... Voir plus');
    });
  }
});
*/

/* Meganav innver menu desktop */
document.querySelectorAll('.mega-menu').forEach(menu => {

  const selects = menu.querySelectorAll('.megaNavSelect');
  const boxes = menu.querySelectorAll('.megaNavInnerBox');

  selects.forEach(item => {

    item.addEventListener('mouseenter', function() {

      const index = this.getAttribute('is-item');

      // remove active from THIS menu only
      selects.forEach(el => el.classList.remove('active'));
      boxes.forEach(el => el.classList.remove('active'));

      // activate hovered selector
      this.classList.add('active');

      // activate matching content INSIDE THIS MENU ONLY
      const target = menu.querySelector('.megaNavInnerBox[is-item="' + index + '"]');
      if (target) {
        target.classList.add('active');
      }

    });

  });

});
/* accordion toggle */
$(document).ready(function () {
  $('.accordion__disclosure, .accordion__box').on('toggle', function () {
    const $this = $(this);

    if ($this.prop('open')) {
      // Close all other accordions of same type
      $(this.tagName)
      $(this).closest('body').find(this.className.split(' ')[0])

      $(this).siblings('.' + this.className.split(' ')[0])

      $(`.${this.className.split(' ')[0]}`).not(this).each(function () {
        $(this).removeAttr('open').attr('aria-expanded', 'false');
      });

      // Set this one as expanded
      $this.attr('aria-expanded', 'true');
    } else {
      $this.attr('aria-expanded', 'false');
    }
  });
});

/*
  // Function to initialize Trustpilot widget on a given element
  function initTrustpilot() {
    var widget = document.getElementById('tttrustpilot-widget');
    if (widget && window.Trustpilot) {
      window.Trustpilot.loadFromElement(widget);
    }
  }

  // Initialize on first page load
  document.addEventListener('DOMContentLoaded', initTrustpilot);

  // Example: reinitialize after variant change via AJAX
  // Replace this with your actual variant change callback
  document.addEventListener('variantChange', function(e) {
    // Update SKU dynamically
    var newSku = e.detail.sku; // pass the new SKU in your event
    var widget = document.getElementById('tttrustpilot-widget');
    if (widget) {
      widget.setAttribute('data-sku', 'BRUM15');
      // Re-load Trustpilot widget
      window.Trustpilot.loadFromElement(widget);
    }
  });

*/

/* table of content articles */
$(document).ready(function() {

  const $toc = $("#toc");
  const $content = $(".articleBody");

  if (!$toc.length || !$content.length) return;

  const $headings = $content.find("h1, h2, h3");
  if (!$headings.length) return;

  $headings.each(function(index) {
    const $heading = $(this);
    const text = $heading.text().trim();
    if (!text) return;

    let id = $heading.attr("id");
    if (!id) {
      id = `heading-${index}`;
      $heading.attr("id", id);
    }

    const level = parseInt($heading.prop("tagName").substring(1));

    const $listItem = $("<li>")
      .addClass(`toc-level-${level}`)
      .append(`<a href="#${id}">${text}</a>`);

    $toc.append($listItem);
  });

});